import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddressAutocomplete from "../AddressAutocomplete";
import { StyledTextField } from "../../utilities/styles/checkoutPage.style";
// Using require to avoid type issues if the file is not fully typed or if path resolution is tricky
const AddressSelector = require("../../pages/checkout/AddressSelector").default;

interface EventAddressSectionProps {
    selectedAddressId?: string;
    savedAddresses?: any[];
    addressName?: string;
    address1?: string;
    city?: string;
    stateProvince?: string;
    postalCode?: string;
    organizationSettings: any;
    classes: any;
    onStateChange: (updates: any) => void;
    onChange: (e: any, fieldName: string) => void;
}

const EventAddressSection: React.FC<EventAddressSectionProps> = ({
    selectedAddressId,
    savedAddresses,
    addressName,
    address1,
    city,
    stateProvince,
    postalCode,
    organizationSettings,
    classes,
    onStateChange,
    onChange,
}) => {
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <Typography
                    sx={{
                        mt: 4,
                        mb: 2,
                        fontSize: { sm: "20px" },
                        fontWeight: 600,
                    }}
                    gutterBottom
                >
                    Address
                </Typography>
                {selectedAddressId !== "" && (
                    <CloseIcon
                        onClick={() =>
                            onStateChange({
                                selectedAddressId: "",
                                address1: "",
                                city: "",
                                stateProvince: "",
                                postalCode: "",
                            })
                        }
                        sx={{
                            fontSize: 24,
                            color: "red",
                            cursor: "pointer",
                        }}
                    />
                )}
            </Box>
            {selectedAddressId !== "" &&
                savedAddresses &&
                savedAddresses?.length > 0 && (
                    <Grid container spacing={2} direction="row">
                        <AddressSelector
                            selectedAddressId={selectedAddressId}
                            addresses={savedAddresses}
                            onAddressSelect={(addressId: any) => {
                                if (addressId === "new") {
                                    onStateChange({
                                        selectedAddressId: "",
                                        addressName: "",
                                        address1: "",
                                        city: "",
                                        stateProvince: "",
                                        postalCode: "",
                                    });
                                } else {
                                    const selectedAddress = savedAddresses?.find(
                                        (address: any) => {
                                            return address?.id === addressId;
                                        }
                                    );
                                    onStateChange({
                                        selectedAddressId: addressId,
                                        address1: selectedAddress?.address1,
                                        city: selectedAddress?.city,
                                        stateProvince: selectedAddress?.stateProvince,
                                        postalCode: selectedAddress?.postalCode,
                                    });
                                }
                            }}
                        />
                        {/* <Grid item xs={12} sm={12}>
                            <Typography variant="caption" component="div" gutterBottom>
                                {organizationSettings?.ordersTermsMessage}
                            </Typography>
                        </Grid> */}
                    </Grid>
                )}
            {((savedAddresses && savedAddresses?.length === 0) ||
                selectedAddressId === "") && (
                    <>
                        <Typography
                            gutterBottom
                            sx={{
                                mt: 4,
                                mb: 2,
                                fontSize: { sm: "20px" },
                                fontWeight: 600,
                            }}
                        >
                            Site Information
                        </Typography>
                        <Grid container spacing={2} direction="row">
                            <Grid item xs={12} sm={12}>
                                <AddressAutocomplete
                                    onPlaceSelect={(place: any) => {
                                        onStateChange({
                                            addressName: place?.name,
                                            address1: place?.address,
                                            city: place?.city,
                                            county: place?.county,
                                            country: place?.country,
                                            postalCode: place?.postalCode,
                                            stateProvince: place?.state,
                                        });
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <StyledTextField
                                    name="city"
                                    autoComplete="address-level2"
                                    className={classes.marginBottom5}
                                    id="city"
                                    value={city}
                                    onChange={(e: any) => onChange(e, "city")}
                                    label="City"
                                    variant="outlined"
                                    fullWidth
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <StyledTextField
                                    name="stateProvince"
                                    autoComplete="address-level1"
                                    className={classes.marginBottom5}
                                    id="siteStateProvince"
                                    value={stateProvince}
                                    onChange={(e: any) => onChange(e, "stateProvince")}
                                    label="State"
                                    variant="outlined"
                                    fullWidth
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <StyledTextField
                                    name="postalCode"
                                    autoComplete="postal-code"
                                    className={classes.marginBottom5}
                                    id="postalCode"
                                    value={postalCode}
                                    onChange={(e: any) => onChange(e, "postalCode")}
                                    placeholder="e.g. 10002"
                                    label="Postal code"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </>
                )}
        </>
    );
};

export default EventAddressSection;
